// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23QzO","col":"styles_col__3Xx2a"};